import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import Dashboard from './Dashboard';
import {
  getConsumptionDetailsInitiate,
  getLandingPageInitiate,
} from '../../actions/company';
import { currentFlowTypeEnum } from '../common/components/constants';

const mapStateToProps = state => {
  const ordersResponse = _get(state, 'company.ordersData', []);
  const landingPageInfo = _get(state, 'company.landing_page_info', {});
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const viewOnlyMode = _get(state, 'user.view_only_mode', false);
  const currentFlow = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  return {
    currentFlow,
    viewOnlyMode,
    landingPageInfo,
    ordersResponse,
    selectedWorkspace,
    fetchinglandingPage:
      _get(state, 'apiState.GET_HOME_PAGE.isFetching', true) &&
      !_get(state, 'apiState.GET_HOME_PAGE.isIdle', false),
    fetchedlandingPage: _get(state, 'apiState.GET_HOME_PAGE.success', true),
    fetchingOrders:
      _get(state, 'apiState.GET_CONSUMPTION_DETAILS.isFetching', true) &&
      !_get(state, 'apiState.GET_CONSUMPTION_DETAILS.isIdle', false),
    fetchedOrders: _get(
      state,
      'apiState.GET_CONSUMPTION_DETAILS.success',
      true,
    ),
  };
};

const mapDispatchToProps = dispatch => ({
  getLandingPageDetails: paylaod => dispatch(getLandingPageInitiate(paylaod)),
  getConsumptions: payload => dispatch(getConsumptionDetailsInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Dashboard);
